import { CompactAllocation } from "../types";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface Props {
    allocation: CompactAllocation;
}

const AllocationPrice: FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ allocation }) => {
    const { t } = useTranslation("space-manager");
    const voucherIds = allocation.bookers?.flatMap((booker) => booker.used_vouchers);
    return (
        <div className="tw-flex tw-justify-center">
            <div className="tw-p-2 tw-px-4 tw-rounded-xl tw-bg-accents-0 tw-text-end">
            <span className="tw-text-accents-9 tw-font-bold tw-block">
                {allocation.price?.toLocaleString("de", { minimumFractionDigits: 2 })} €
            </span>
                <span className="tw-text-xs tw-text-accents-7 tw-block">{t("allocationList.totalPrice")}</span>
                {voucherIds?.length > 0 && (
                    <span className="tw-text-xs tw-text-accents-5"
                    >{t("allocationList.usedVouchers", { ids: voucherIds.join(", ") })}</span>)}
            </div>
        </div>
    );
};

export default AllocationPrice;